<template>
    <div class="padded">

    <el-row>
      <el-col :span="24">
        <h1>{{site.siteName}}</h1>&nbsp;<h4>{{site.siteId}}</h4>
        <el-alert v-if="site.tenancy && isArray(site.tenancy)" type="info" :title="'Site has ' + plural('landowner', site.tenancy.length, true)" :closable="false" show-icon />
        <span v-if="!site.address && site.zone">&nbsp;<strong>{{site.zone}}</strong></span>
      </el-col>

    </el-row>

    <el-row>
      <el-col :span="12">
        <i>{{site.subdistrict}}</i> <i v-if="site.district"><span v-if="site.subdistrict">, </span>{{site.district}}</i>
        <i v-if="site.state"><span v-if="site.district || site.subdistrict">, </span>{{site.state}}</i>
        <i v-if="site.region"><span v-if="site.district || site.subdistrict || site.state">, </span>{{site.region}}</i>
        <i v-if="site.country"><span v-if="site.district || site.subdistrict || site.region || site.state">, </span>{{site.country}}</i>
      </el-col>
    </el-row>

    <el-row v-if="site.address || site.zone">
      <el-col :span="14">
        <strong v-if="site.address">{{site.address}}&nbsp;</strong>
        <span v-if="site.zone">Zone:&nbsp;<strong>{{site.zone}}</strong></span>
      </el-col>

      <el-col :span="10" v-if="site.latitude && site.longitude">
        <small>lat:</small>&nbsp;<strong>{{site.latitude}}</strong> / <small>lng:</small>&nbsp;<strong>{{site.longitude}}</strong>
      </el-col>
    </el-row>

    <br />

    <el-tabs>

      <el-tab-pane v-if="tenancy"
          label="Tenancy" icon="fa fa-map">

          <div v-if="!isArray(tenancy)">
            <tenancy
                :row-data="rowData"
                :index="0"
                :tenancy-data="tenancy"
                :show-renewal-button="true"
                :hide-delete="true"
                :editable="false" />
          </div>

          <div v-else>
            <el-collapse accordion v-model="selected" v-for="(t, index) in tenancy" :key="index">

               <el-collapse-item :name="index">
                 <template slot="title">
                   <span class="text-primary">{{(index+1) + ')'}}&nbsp;<b>{{t.owner && t.owner.name ? t.owner.name : 'Not Found'}}</b></span>
                 </template>

                 <tenancy
                  :row-data="rowData"
                  :index="index"
                  :tenancy-data="t"
                  :show-agreement="true"
                  :hide-delete="true"
                  :editable="false" />

               </el-collapse-item>

            </el-collapse>
          </div>

    </el-tab-pane>

    <el-tab-pane label="Location Map" icon="fa fa-map">
      <site-card ref="siteCard"
        v-if="site.site_id ? site.site_id : site.id"
        :site-data="site"
        no-shadow
        :sharer-id="isTelco() ? this.org().id : null" />
    </el-tab-pane>

    <el-tab-pane label="Sharer" icon="fa fa-wifi">
        <site-sharers :no-add="true" :read-only="true" :row-data="site" />
    </el-tab-pane>

</el-tabs>

<el-row>
  <el-col :span="8">
    <small  v-if="site.handover">Handover </small>&nbsp;
    <strong v-if="site.handover">{{formatDate(site.handover)}}</strong>
  </el-col>

    <el-col :span="7" :offset="1">
      &nbsp;<small v-if="site.billing">Commencement</small>
      <strong v-if="site.billing">{{formatDate(site.billing)}}</strong>
    </el-col>

  </el-row>
</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import SiteCard from '@/components/sites/SiteCard'

import SiteSharers from '@/components/sites/SiteSharers'
import Tenancy from '@/components/property/Tenancy'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    SiteSharers,
    SiteCard,
    Tenancy
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  watch: {
    tenancy: function (value) {
      this.tenancy = value
    }
  },

  data () {
    return {
      selected: 0,
      site: this.rowData.site ? this.rowData.site : this.rowData,
      owner: null,
      tenancy: this.rowData.tenancy,
      fields: [
        {
          name: 'term',
          title: 'Renewals',
          callback: this.addSuffix
        },
        {
          name: 'started',
          title: 'Started',
          callback: this.formatDate
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate
        },
        {
          name: 'amount',
          title: 'Rental',
          callback: this.formatNumber
        },
        {
          name: 'increment',
          title: 'Incr. %',
          callback: this.formatPercent
        }
      ]
    }
  },

  created () {

    if (this.tenancy.owner) {
      this.owner = this.tenancy.owner
    }
  }
}
</script>



// WEBPACK FOOTER //
// PropertyDetails.vue?7fd2738c